import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/info.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-5a47e1b7")

_pushScopeId("data-v-5a47e1b7")
const _hoisted_1 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6 p-1  mx-auto w-600px items-start" }
const _hoisted_2 = { class: "flex flex-col justify-start items-start w-full" }
const _hoisted_3 = { class: "text-sm font-bold text-gray-900 mb-3" }
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = {
  key: 0,
  "data-testid": "pickup-schedule-config-error-duplicate-date",
  class: "text-xs text-red-lp-100 font-medium mt-2"
}
const _hoisted_6 = { class: "md:border-l md:border-gray-200 md:pl-6 flex flex-col" }
const _hoisted_7 = { class: "text-sm font-semibold text-gray-800 mb-3" }
const _hoisted_8 = { class: "overflow-y-auto border border-gray-200 rounded-xl p-3 flex flex-col gap-2.5 custom-scroll max-h-76" }
const _hoisted_9 = {
  "data-testid": "pickup-schedule-config-modal-note-max-slots",
  class: "text-xs text-gray-500 flex items-center gap-1.5 mt-2"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-3.5 h-3.5 flex-shrink-0",
  alt: "info"
}, null, -1)
const _hoisted_11 = { class: "flex w-full pt-2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_CheckboxV2 = _resolveComponent("CheckboxV2")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!

  return (_ctx.open)
    ? (_openBlock(), _createBlock(_component_ModalV2, {
        key: 0,
        "data-testid": "pickup-schedule-config-modal-pick-schedule",
        title: 
      _ctx.$t('pickup.scheduleConfig.special.modalTitle') || 'Pilih jadwal Pick Up'
    ,
        width: "w-667px",
        onClose: _ctx.onCloseModal,
        closeButtonTestId: "pickup-schedule-config-modal-pick-schedule-button-close"
      }, {
        content: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("pickup.scheduleConfig.special.pickDateLabel") ||
                "Pilih tanggal"), 1),
              _createVNode("div", _hoisted_4, [
                _createVNode(_component_Calendar, {
                  modelValue: _ctx.draftDate,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.draftDate = $event)),
                  inline: "",
                  minDate: _ctx.minDateObj,
                  disabledDates: _ctx.disabledDateObjects,
                  panelClass: "custom-inline-datepicker",
                  "data-testid": "pickup-schedule-config-modal-calendar",
                  class: "custom-inline-calendar w-full",
                  onDateSelect: _ctx.onDateSelect
                }, null, 8, ["modelValue", "minDate", "disabledDates", "onDateSelect"])
              ]),
              (_ctx.duplicateDateError)
                ? (_openBlock(), _createBlock("p", _hoisted_5, _toDisplayString(_ctx.$t("pickup.scheduleConfig.special.duplicateDate") ||
                "Tanggal ini sudah ditambahkan"), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode("div", null, [
                _createVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("pickup.scheduleConfig.special.pickTimeLabel") || "Pilih jam"), 1),
                _createVNode("div", _hoisted_8, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.slotOptions, (slot) => {
                    return (_openBlock(), _createBlock(_component_CheckboxV2, {
                      key: slot.start,
                      label: slot.label,
                      value: _ctx.draftStarts.includes(slot.start),
                      disabled: _ctx.isSlotDisabled(slot.start),
                      "data-testid": 
                  `pickup-schedule-config-modal-time-option-${slot.start.replace(
                    ':',
                    ''
                  )}`
                ,
                      "onUpdate:value": (v) => _ctx.toggleSlot(slot.start, v)
                    }, null, 8, ["label", "value", "disabled", "data-testid", "onUpdate:value"]))
                  }), 128))
                ])
              ]),
              _createVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode("span", null, _toDisplayString(_ctx.$t("pickup.scheduleConfig.special.modalMaxSlotsNote") ||
                  "Maks. 3 jadwal per hari."), 1)
              ])
            ])
          ])
        ]),
        footer: _withId(() => [
          _createVNode("div", _hoisted_11, [
            _createVNode(_component_LpButton, {
              title: _ctx.$t('pickup.scheduleConfig.special.save') || 'Simpan',
              isWidthFull: true,
              disabled: !_ctx.canSave,
              color: _ctx.canSave ? 'red-lp-2400' : 'gray-lp-400',
              textColor: "white",
              "data-testid": "pickup-schedule-config-modal-button-save",
              onClick: _ctx.onSave
            }, null, 8, ["title", "disabled", "color", "onClick"])
          ])
        ]),
        _: 1
      }, 8, ["title", "onClose"]))
    : _createCommentVNode("", true)
})